@if (mode === "default") {
  <div class="flex flex-col flex-1 gap-2">
    @if (preview && !hideInfoInternalData) {
      <div class="grid grid-cols-3 py-1 border-b border-slate-100">
        <span class="text-base font-bold uppercase text-slate-900">
          {{ "Informazioni ad uso interno" | transloco }}
        </span>
      </div>
    }
    <div class="flex flex-col flex-1 gap-4">
      @if (!hideCustomerAndPatientData && designModel) {
        <div class="grid grid-cols-3 text-xs gap-x-2 gap-y-1">
          <div class="flex flex-row items-center">
            <span class="text-sm text-slate-600">{{
              "Paziente" | transloco
            }}</span>
            <span class="ml-auto text-sm font-bold text-slate-900">{{
              designModel?.patientName
            }}</span>
          </div>
          @if (designModel?.patientSpecies) {
            <div class="flex flex-row items-center">
              <span class="text-sm text-slate-600">{{
                "Specie" | transloco
              }}</span>
              <span class="ml-auto text-sm font-bold">{{
                designModel?.patientSpecies
              }}</span>
            </div>
          }
          @if (designModel?.patientBreed) {
            <div class="flex flex-row items-center">
              <span class="text-sm text-slate-600">{{
                "Razza" | transloco
              }}</span>
              <span class="ml-auto text-sm font-bold">{{
                designModel?.patientBreed
              }}</span>
            </div>
          }
          @if (designModel?.patientBirthday) {
            <div class="flex flex-row items-center">
              <span class="text-sm text-slate-600">{{
                "Data di nascita" | transloco
              }}</span>
              <span class="ml-auto text-sm font-bold">{{
                designModel?.patientBirthday
              }}</span>
            </div>
          }
          @if (designModel?.patientSex) {
            <div class="flex flex-row items-center">
              <span class="text-sm text-slate-600">{{
                "Sesso" | transloco
              }}</span>
              <span class="ml-auto text-sm font-bold"
                >{{ designModel?.patientSex }}
              </span>
            </div>
          }
          @if (designModel?.patientMicrochip) {
            <div class="flex flex-row items-center">
              <span class="text-sm text-slate-600">{{
                "Microchip" | transloco
              }}</span>
              <span class="ml-auto text-sm font-bold">{{
                designModel?.patientMicrochip
              }}</span>
            </div>
          }
          @if (designModel?.customerNominative) {
            <div class="flex flex-row items-center">
              <span class="text-sm text-slate-600">{{
                "Cliente" | transloco
              }}</span>
              <span class="ml-auto text-sm font-bold">{{
                designModel?.customerNominative
              }}</span>
            </div>
          }
          @if (designModel?.customerPhone) {
            <div class="flex flex-row items-center">
              <span class="text-sm text-slate-600">{{
                "Telefono" | transloco
              }}</span>
              <span class="ml-auto text-sm font-bold">{{
                designModel?.customerPhone
              }}</span>
            </div>
          }
          @if (designModel?.customerEmail) {
            <div class="flex flex-row items-center">
              <span class="text-sm text-slate-600">{{
                "Email" | transloco
              }}</span>
              <span class="ml-auto text-sm font-bold">{{
                designModel?.customerEmail
              }}</span>
            </div>
          }
          @if (designModel?.patientSterilized) {
            <div class="flex flex-row items-center">
              <span class="text-sm text-slate-600">{{
                "Sterilizzato" | transloco
              }}</span>
              <span class="ml-auto text-sm font-bold">{{
                designModel?.patientSterilized
              }}</span>
            </div>
          }
          @if (formData?.weight) {
            <div class="flex flex-row items-center">
              <span class="text-sm text-slate-600">{{
                "Peso" | transloco
              }}</span>
              <span class="ml-auto text-sm font-bold">
                {{ formData?.weight }} kg
              </span>
              <span class="ml-1">
                <snt-button-icon
                  [disabled]="!isCreatedToday()"
                  [icon]="'fa-light fa-gauge-circle-plus'"
                  [title]="'Registra Peso'"
                  (onClick)="onRegisterWeight()"
                >
                </snt-button-icon>
              </span>
            </div>
          }
        </div>
      }
      <div class="flex flex-row items-center"></div>
      @if (editMode === "soap") {
        <dx-form
          [formData]="formData"
          [labelLocation]="'top'"
          [showColonAfterLabel]="false"
          (onFieldDataChanged)="onFieldDataChanged()"
          class="flex-1"
          [readOnly]="readOnly"
        >
          <dxi-item itemType="group" [colCount]="3">
            <dxi-item>
              <div *dxTemplate>
                <pms-soap-template-authors
                  [readOnly]="readOnly"
                  [preview]="preview"
                  [authors]="formData.staff"
                  (data)="formData.staff = $event.tags; onFieldDataChanged()"
                ></pms-soap-template-authors>
              </div>
            </dxi-item>
            <dxi-item
              dataField="title"
              editorType="dxTextBox"
              [label]="{ text: 'Titolo' | transloco }"
              [colSpan]="2"
            ></dxi-item>
          </dxi-item>
          <dxi-item itemType="group" [colCount]="3">
            <dxi-item>
              <div *dxTemplate>
                <pms-soap-template-organs
                  [tags]="formData.organs || []"
                  [preview]="preview"
                  [readOnly]="readOnly"
                  (data)="formData.organs = $event.tags; onFieldDataChanged()"
                ></pms-soap-template-organs>
              </div>
            </dxi-item>
            <dxi-item [colSpan]="2">
              <div *dxTemplate>
                <pms-soap-template-diagnosis
                  [tags]="formData.diagnosis || []"
                  [preview]="preview"
                  [readOnly]="readOnly"
                  (data)="
                    formData.diagnosis = $event.tags; onFieldDataChanged()
                  "
                ></pms-soap-template-diagnosis>
              </div>
            </dxi-item>
          </dxi-item>
          <dxi-item
            dataField="internalNote"
            editorType="dxTextArea"
            [label]="{ text: 'Note interne' | transloco }"
            [editorOptions]="{ readOnly: preview }"
          ></dxi-item>
        </dx-form>
        @if (!readOnly) {
          <div class="flex flex-row flex-wrap gap-2">
            <snt-button
              [title]="'Crea ricetta' | transloco"
              icon="fa-file-prescription fa-light"
              [small]="true"
              (onClickAsync)="onCreatePrescription($event)"
            ></snt-button>
          </div>
        }
      }
    </div>
  </div>
}

@if (mode === "placeholder") {
  <div class="flex flex-col items-center justify-center flex-1 h-16 gap-0 p-4">
    <span class="text-lg font-light text-slate-400">{{
      "Sommario" | transloco
    }}</span>
    <span class="text-base font-light text-slate-400">
      {{ "Dati del cliente, del paziente e altri dati." | transloco }}
    </span>
  </div>
}
